import { render, staticRenderFns } from "./EventSummaryInfo.vue?vue&type=template&id=73f652dc&scoped=true&"
import script from "./EventSummaryInfo.vue?vue&type=script&lang=js&"
export * from "./EventSummaryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f652dc",
  null
  
)

export default component.exports